import { instance, errorService } from '@/services/api'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { formatCurrency } from '@/services/convert'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'

export default {
  props: ['url', 'assetId', 'assetDescription'],
  components: {
    'ag-grid-vue': AgGridVue,
  },
  data: function() {
    return {
      loading: true,
      list: [],
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      width: '100%',
      height: '5rem',
      modalWidth: '70rem',
      padding: '0px',
      visible: false,
      totalCost: 0,
      formatCurrency: formatCurrency,
    }
  },
  beforeMount() {
    this.visible = true
    this.loadingConfig()
    window.addEventListener('resize', this.detectViewPortListener)
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: false,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: false,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        suppressContextMenu: true,
        defaultColDef: {
          sortable: false,
          suppressMovable: true,
          resizable: false,
          editable: false,
          filter: false,
          menuTabs: [],
        },
      }
      this.frameworkComponents = {
        toolTipRenderer: ToolTipRenderer,
        costPriceCellRenderer: CurrencyRenderer,
      }
      this.columnDefs = [
        {
          field: 'assetDescription',
          headerTooltip: 'Asset Description',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          width: 150,
          wrapText: true,
          cellRenderer: 'toolTipRenderer',
          pinned: 'left',
          resizable: true,
        },
        {
          field: 'customIndirect',
          headerTooltip: 'Custom Indirect',
          headerClass: 'header-right',
          cellStyle: { textAlign: 'right' },
          width: 120,
          wrapText: false,
          cellRenderer: 'costPriceCellRenderer',
        },
        {
          field: 'buildingIndirect',
          headerTooltip: 'Building Indirect',
          headerClass: 'header-right',
          cellStyle: { textAlign: 'right' },
          width: 120,
          wrapText: false,
          cellRenderer: 'costPriceCellRenderer',
        },
        {
          field: 'projectIndirect',
          headerTooltip: 'Project Indirect',
          headerClass: 'header-right',
          cellStyle: { textAlign: 'right' },
          width: 120,
          wrapText: false,
          cellRenderer: 'costPriceCellRenderer',
        },
        {
          field: 'globalIndirect',
          headerTooltip: 'Global Indirect',
          headerClass: 'header-right',
          cellStyle: { textAlign: 'right' },
          width: 120,
          wrapText: false,
          cellRenderer: 'costPriceCellRenderer',
        },
        {
          field: 'totalIndirect',
          headerTooltip: 'Total Indirect',
          headerClass: 'header-right',
          cellStyle: { textAlign: 'right' },
          width: 120,
          wrapText: false,
          cellRenderer: 'costPriceCellRenderer',
        },
      ]
    },

    onLoad(params) {
      this.loading = true
      params.api.sizeColumnsToFit()
      params.api.setColumnDefs(this.columnDefs)
      params.api.sizeColumnsToFit()
      instance
        .get(this.url)
        .then(response => {
          let data = _.get(response.data, 'result', [])
          if (data.length > 0) {
            data.map(i => {
              i.assetDescription = this.assetDescription
              Object.assign(i, {
                totalIndirect:
                  _.get(i, 'customIndirect', 0) +
                  _.get(i, 'buildingIndirect', 0) +
                  _.get(i, 'projectIndirect', 0) +
                  _.get(i, 'globalIndirect', 0),
              })
              this.totalCost = i.totalIndirect
            })
          }
          this.totalCost = data.reduce((total, item) => {
            return total + _.get(item, 'totalIndirect', 0)
          }, 0)
          data = data.filter(i => i.assetId === this.assetId)
          params.api.setRowData(data)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    onClose() {
      this.visible = false
      this.$emit('closeIndirectCostInfo')
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.modalWidth = '70rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.modalWidth = '100%'
        this.padding = '10px !important'
      } else {
        this.modalWidth = '70rem'
        this.padding = '0px !important'
      }
    },
  },
}
